module.exports = __webpack_public_path__ + "assets/CRIM-Logo.381482a1bebe45fd6ead916f278d2008.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/CRIM-Logo.gif
// module id = ./src/assets/images/CRIM-Logo.gif
// module chunks = app